var React = require('react');

function ShareTwWhite (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z","fill":"white","key":0}),React.createElement("path",{"d":"M10.3843 8.76749L13.8448 4.74487H13.0248L10.02 8.23771L7.62009 4.74487H4.85211L8.48127 10.0266L4.85211 14.2449H5.67212L8.84528 10.5563L11.3797 14.2449H14.1477L10.384 8.76749H10.3841H10.3843ZM9.26106 10.0731L8.89341 9.54712L5.96773 5.36222H7.22727L9.58834 8.73962L9.95599 9.26561L13.0251 13.6557H11.7656L9.26106 10.0734V10.0731Z","fill":"#0D1933","key":1})]);
}

ShareTwWhite.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = ShareTwWhite;

ShareTwWhite.default = ShareTwWhite;
